/** @prettier */
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import lpAnalyticsLogo from 'assets/images/LP-Analytics-Studio_Logo_Stacked.svg';
import lpLogoSmall from 'assets/images/LP-Sun-2022-RGB-Orange.svg';

const ImgStyle = styled.img`
  width: 100%;
`;

const Logo = ({ collapsed, onClick, theme }) => {
  return (
    <div role="button" aria-hidden="true" tabIndex={0} onClick={onClick} className="isoLogoWrapper">
      {collapsed ? (
        <div>
          <h3>
            <Link to="/app">
              <img data-testid="logo-img" className="voicebaseLogomark" src={lpLogoSmall} alt="Analytics Studio" />
            </Link>
          </h3>
        </div>
      ) : (
        <h3>
          <Link to="/app">
            <ImgStyle
              data-testid="logo-img"
              role="img"
              className="voicebaseLogo"
              src={lpAnalyticsLogo}
              alt="LivePerson Analytics"
            />
          </Link>
        </h3>
      )}
    </div>
  );
};

export default Logo;
